<template>
    <div v-if="this.value !== null">
        <span>{{this.value}}</span>
        <i>{{this.unit}}</i>
    </div>
    <div v-else>
        <span>{{this.$t('common.value.notAvailable')}}</span>
    </div>
</template>
<script>
	export default {
		props: {
			value: null,
			unit: {type:String, default:""}
		}
	};
</script>